export const getCurrentLanguageDescription = state => {
  let currentLanguage = ''
  state.language.languages.forEach((language) => {
    currentLanguage = language.name === state.i18n.locale ? language.description : currentLanguage
  })
  return currentLanguage
}



// WEBPACK FOOTER //
// ./src/store/getters.js